<template>
  <v-app id="nikoApp" :style="{ height: height }" ref="app">
    <toolbar v-if="$route.meta.showToolbar" />

    <niko-premium-banner
      v-if="
        $route.fullPath === '/' &&
        (activeSubscription === false || fastspringAccountId === undefined)
      "
    />
    <niko-news v-if="$route.fullPath === '/'" />

    <v-content style="overflow: hidden">
      <v-container
        fluid
        class="fill-height pa-0"
        style="background-color: #1a1a1a !important"
      >
        <router-view />
        <niko-loader :isLoading="loading && !generatingPdf" />
        <niko-pdf-loader v-if="generatingPdf" />
        <guidance />
      </v-container>
    </v-content>
    <internet-connection-banner />
  </v-app>
</template>

<script>
import * as localForage from "localforage";
import { Auth } from "aws-amplify";
import { mapState, mapActions } from "vuex";
import NikoLoader from "@/components/UI/NikoLoader";
import NikoPdfLoader from "@/components/UI/NikoPdfLoader";
import InternetConnectionBanner from "@/components/UI/InternetConnectionBanner";
import Toolbar from "@/components/Toolbar";
import Guidance from "@/components/guidance/Guidance";
import { eventBus } from "@/components/EventBus";
import i18n from "./i18n";
import NikoPremiumBanner from "@/components/UI/NikoPremiumBanner";
import NikoNews from "@/components/UI/NikoNews.vue";

export default {
  name: "app",
  components: {
    Toolbar,
    NikoLoader,
    NikoPdfLoader,
    InternetConnectionBanner,
    Guidance,
    NikoPremiumBanner,
    NikoNews,
  },
  data: () => ({
    height: window.innerHeight,
  }),
  methods: {
    ...mapActions("projectStore", [
      "subscribeSetFlag",
      "unsubscribeSetFlag",
      "getAvailableStandards",
    ]),
    ...mapActions("authStore", ["setFastspringAccountIdAttribute"]),
    calculateHeight() {
      if (this.$refs.app) {
        this.height = `${window.innerHeight}px`;
        eventBus.$emit("heightChange", window.innerHeight);
      }
    },
  },
  async created() {
    localForage.removeItem("reduxPersist::appsync");
    localForage.removeItem("reduxPersist::appsync-metadata");
    localForage.removeItem("reduxPersist::offline");
    document.title = i18n.t("tab_label.fa_assistant");
    this.subscribeSetFlag();
    const user = await Auth.currentUserInfo();
    if (user) {
      this.getAvailableStandards();
    }
  },
  computed: {
    ...mapState("loaderStore", ["loading"]),
    ...mapState("authStore", ["activeSubscription", "fastspringAccountId"]),
    ...mapState("projectStore", ["generatingPdf"]),
  },
  mounted() {
    window.addEventListener("resize", this.calculateHeight);
    this.calculateHeight();
    addEventListener("accountIdReceived", (event) => {
      this.setFastspringAccountIdAttribute({
        accountId: event.detail,
        recheckStatus: true,
      });
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.calculateHeight);
    removeEventListener("accountIdReceived", (event) => {
      this.setFastspringAccountIdAttribute({
        accountId: event.detail,
        recheckStatus: true,
      });
    });
    this.unsubscribeSetFlag();
  },
};
</script>

<style lang="scss">
@import "./assets/styles/typography.scss";

html {
  overflow-y: auto !important;
}

body {
  touch-action: pan-x pan-y;
}

#nikoApp {
  position: fixed;
  width: 100vw;

  &::-webkit-scrollbar {
    background-color: #202324;
    color: #aba499;
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #454a4d;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: #575e62;
  }
  &::-webkit-scrollbar-thumb:active {
    background-color: #484e51;
  }
  &::-webkit-scrollbar-corner {
    background-color: #181a1b;
  }
}

.v-application--wrap {
  min-height: initial !important;
}
</style>
